// 基础信息编辑处理
export const state = () => {
  return {
    companyInfo: {},
    // 投资机构
    inInvestDTOS: [],
    // 对外投资
    outInvestDTOS: [],
    // 企业3D
    thirddFileVOS: [],
    // 企业营业执照
    business_license: {},
    identity: {},
    identity_rev: {},
    letter: {},
    // 仅用来填充空数据, 无其他作用
    baseMulLangFieldList: [
      {
        companyName: '',
        description: '',
        video: '',
        address: '',
        mainProducts: '',
        listedCountry: '',
        listedInstitutions: '',
        langType: 'zh',
      },
      {
        companyName: '',
        description: '',
        video: '',
        address: '',
        mainProducts: '',
        listedCountry: '',
        listedInstitutions: '',
        langType: 'en',
      },
    ],
    /**
     * 升级会员的modal信息
     * isShow
     * upgradeType cert:认证 upgrade:升级
     * tips 提示文案
     * */
    upgradeModalInfo: {
      isShow: false,
      upgradeType: '',
      tips: '',
    },
    // 新版本的modal, 只有升级会员
    upgradeVipModalInfo: {
      isShow: false,
      tips: '',
    },

    // 当前的供应链信息
    supplyChainInfo: {
      id: '',
      unicode: '',
      title: '',
    },
  }
}

export const mutations = {
  /**
   * @description: 编辑数据初始化, 并对后端传过来的数据进行处理
   * @param {*} state
   * @param {*} data
   * @return {*}
   */
  baseInfoInit(state, data) {
    // console.log('baseInfoInit', data)
    if (data.files && data.files.length) {
      data.files.map((item) => {
        switch (item.fileKey) {
          case 'identity':
            state.identity = item
            break
          case 'identity_rev':
            state.identity_rev = item
            break
          case 'business_license':
            state.business_license = item
            break
          case 'letter':
            state.letter = item
            break
        }
      })
    }

    // 全部信息
    state.companyInfo = data

    // TODO 代码不够优雅, 以后看看有没有判断数组是否item为空, 如果为空替换的方法
    /**
     * 因为后端可能只返回一种语言, 且顺序不一定正确
     * 中文的排到英文前面, 并且替换空值
     * */

    state.companyInfo.mulLangFieldList.map((item) => {
      if (item.langType === 'zh') {
        state.baseMulLangFieldList[0] = {
          ...state.baseMulLangFieldList[0],
          ...item,
        }
      } else {
        state.baseMulLangFieldList[1] = {
          ...state.baseMulLangFieldList[1],
          ...item,
        }
      }
    })

    state.companyInfo.mulLangFieldList = state.baseMulLangFieldList
  },
  /**
   *
   * 编辑信息, 编辑后提交按原来的地
   * @param {*} state
   * @param {*} data
   */
  editBaseInfo(state, data) {
    switch (data.type) {
      case 'info':
        state.companyInfo.info[data.subType] = data.val
        break
      case 'files':
        state.fileKeys = []
        state.companyInfo.files.map((item) => {
          state.fileKeys.push(item.fileKey)
          console.log('item.fileKey', item.fileKey, data.subType)
          if (item.fileKey === data.subType) {
            item.fileUrl = data.val
          }
        })
        // for (const item of state.companyInfo.files) {
        //   state.fileKeys.push(item.fileKey)
        //   console.log('item.fileKey', item.fileKey, data.subType)
        //   if (item.fileKey === data.subType) {
        //     item.fileUrl = data.val
        //     break
        //   }
        // }

        // 如果不存在则增加
        if (!state.fileKeys.includes(data.subType)) {
          state.companyInfo.files.push({
            fileExt: '',
            fileKey: data.subType,
            fileUrl: data.val,
            title: '',
          })
        }
        break
      case 'all':
        state.companyInfo = data.val
    }
    // console.log('state', state)
  },
  /**
   * @description: 切换升级会员的modal信息
   * @param {*} state
   * @param {*} data
   * @return {*}
   */
  SWITCH_UPGRADE_MODAL(state, data) {
    console.log('SWITCH_UPGRADE_MODAL', data)
    state.upgradeModalInfo = data
  },
  SWITCH_UPGRADE_VIP_MODAL(state, data) {
    console.log('SWITCH_UPGRADE_VIP_MODAL', data)
    state.upgradeVipModalInfo = data
  },
  SET_SUPPLY_CHAIN(state, data) {
    state.supplyChainInfo = data
  },
}
export const actions = {}
